/*
 * WEB-3596 — Centralised HTML output-encoding helper.
 *
 * Defence-in-depth complement to the WEB-3592 backend input-validation rollout.
 * Use this to text-encode any user-entered / user-stored value BEFORE it is
 * inserted into an HTML sink (jQuery .html()/.append()/.prepend(), string-built
 * markup, etc.). This prevents stored XSS the same way the WEB-3573 fix in
 * core/nice-select.js does, but as a single shared function rather than a
 * per-call-site copy, and it also escapes the attribute-context characters
 * (" and ') so it is safe in both element-content and attribute positions.
 *
 * Lives in core/ so gulp concatenates it into public/js/core.js, which the
 * layout blades load (as a plain <script>) BEFORE the rollup'd view/component
 * bundles. window.ssEscapeHtml is therefore defined before any view runtime
 * code calls it.
 *
 * SCOPE: plain-text fields only (names, labels, descriptions, etc.). Fields that
 * INTENTIONALLY hold rich text — e.g. PropertyQuestion.question_text rendered via
 * ng-bind-html/$sce.trustAsHtml — must be HTML-sanitised (allow-list), never
 * escaped, or their legitimate formatting is destroyed. That is tracked in the
 * separate Category-B follow-up ticket, not here.
 */
(function (window) {
    'use strict';

    var HTML_ESCAPES = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };

    /**
     * HTML-escape a value for safe insertion into an HTML sink.
     *
     * @param {*} value The value to escape. null / undefined become ''.
     * @returns {string} The HTML-escaped string.
     */
    function ssEscapeHtml(value) {
        if (value === null || value === undefined) {
            return '';
        }

        return String(value).replace(/[&<>"']/g, function (chr) {
            return HTML_ESCAPES[chr];
        });
    }

    window.ssEscapeHtml = ssEscapeHtml;
})(window);
